import React from "react";
import Button from "./Button";
import useReveal from "../hooks/useReveal";
import { SITE } from "../data/siteConfig";

const FALLBACK_IMG =
  "https://images.unsplash.com/photo-1581428982868-e410dd047a90?auto=format&fit=crop&w=900&q=80";

const handleImgError = (e) => {
  if (e.currentTarget.src !== FALLBACK_IMG) e.currentTarget.src = FALLBACK_IMG;
};

const PERKS = [
  "Custom to your measurements",
  "Premium seasoned timber",
  "Delivery across India",
];

export default function CTA({
  eyebrow = "Get Started",
  title = "Let's Build Your Dream Furniture",
  description = "Share your space and requirements. Our craftsmen will design and build furniture made to fit your home perfectly.",
  buttonLabel = "Contact Us",
  buttonTo = "/contact",
  phone = "9447297179",
  bgImage = "/assets/7.png",
  imageOne = {
    src: "/assets/33.png",
    alt: "Handcrafted wooden furniture from the Anappuram workshop",
  },
  imageTwo = {
    src: "/assets/17.png",
    alt: "Craftsman working on a custom wooden piece",
  },
}) {
  const [ref, isVisible] = useReveal();

  return (
    <div
      className={`container reveal-zoom ${isVisible ? "is-visible" : ""}`}
      ref={ref}
    >
      <div className="cta-banner">
        {/* Background photo + overlay */}
        <img
          className="cta-banner__bg"
          src={bgImage}
          alt=""
          aria-hidden="true"
          loading="lazy"
          onError={handleImgError}
        />
        <div className="cta-banner__shade" aria-hidden="true" />
        <span className="cta-banner__glow" aria-hidden="true" />

        <div className="cta-banner__inner">
          {/* Text side */}
          <div className="cta-banner__content">
            <span className="cta-banner__eyebrow">{eyebrow}</span>
            <h2>{title}</h2>
            <p>{description}</p>

            <ul className="cta-banner__perks">
              {PERKS.map((perk) => (
                <li key={perk}>
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                  >
                    <path d="M5 12l5 5 9-10" />
                  </svg>
                  {perk}
                </li>
              ))}
            </ul>

            <div className="cta-banner__actions">
              <Button to={buttonTo} variant="on-dark">
                {buttonLabel}
              </Button>
              <a
                className="cta-banner__link cta-banner__link--wa"
                href={SITE.whatsappLink}
                target="_blank"
                rel="noreferrer"
              >
                <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="M20.5 3.5A11.8 11.8 0 0012 0C5.4 0 0 5.4 0 12c0 2.1.6 4.2 1.6 6L0 24l6.2-1.6A12 12 0 0012 24c6.6 0 12-5.4 12-12 0-3.2-1.2-6.2-3.5-8.5zM12 21.9c-1.8 0-3.6-.5-5.1-1.4l-.4-.2-3.700 1 1-3.600-.2-.4A9.900 9.900 0 012.100 12C2.100 6.500 6.500 2.100 12 2.100c2.600 0 5.100 1 7 2.900a9.800 9.800 0 012.900 7c0 5.500-4.400 9.900-9.900 9.900zm5.400-7.400c-.3-.1-1.800-.9-2-1-.3-.1-.5-.1-.7.1l-.9 1.100c-.2.200-.3.200-.6.100-.3-.1-1.200-.5-2.300-1.400-.9-.8-1.400-1.700-1.600-2-.2-.3 0-.5.100-.6l.4-.5.300-.5c.1-.2 0-.4 0-.5-.1-.1-.7-1.600-.9-2.200-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.100-.8.400-.3.300-1 1-1 2.500s1.100 2.900 1.200 3.100c.1.200 2.100 3.200 5.100 4.500.7.300 1.300.5 1.700.6.700.2 1.400.2 1.900.1.600-.1 1.800-.7 2-1.400.3-.7.300-1.300.2-1.400-.1-.1-.3-.2-.6-.3z" />
                </svg>
                WhatsApp Us
              </a>
              <a className="cta-banner__link" href={`tel:+91${phone}`}>
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <path d="M22 16.9v3a2 2 0 01-2.200 2 19.800 19.800 0 01-8.600-3.100 19.500 19.500 0 01-6-6A19.800 19.800 0 012.100 4.200 2 2 0 014.100 2h3a2 2 0 012 1.700c.1 1 .4 1.900.7 2.800a2 2 0 01-.5 2.100L8.100 9.900a16 16 0 006 6l1.300-1.300a2 2 0 012.100-.4c.9.300 1.800.6 2.800.7a2 2 0 011.700 2z" />
                </svg>
                Call {phone}
              </a>
            </div>
          </div>

          {/* Image side */}
          <div className="cta-banner__media" aria-hidden="false">
            <div className="cta-banner__frame cta-banner__frame--one">
              <img
                src={imageOne.src}
                alt={imageOne.alt}
                loading="lazy"
                onError={handleImgError}
              />
            </div>
            <div className="cta-banner__frame cta-banner__frame--two">
              <img
                src={imageTwo.src}
                alt={imageTwo.alt}
                loading="lazy"
                onError={handleImgError}
              />
            </div>
            <div className="cta-banner__badge">
              <strong>Since 1990</strong>
              <span>Kinassery, Palakkad</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
